import { render, staticRenderFns } from "./SecurityGuard.vue?vue&type=template&id=537852d2&scoped=true"
import script from "./SecurityGuard.vue?vue&type=script&lang=js"
export * from "./SecurityGuard.vue?vue&type=script&lang=js"
import style0 from "./SecurityGuard.vue?vue&type=style&index=0&id=537852d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537852d2",
  null
  
)

export default component.exports